import { List, ListIcon, ListItem, ListProps } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { IconCircleCheckFilled } from '@/shared/ui';

type ListItemsProps = {
  items: string[];
} & ListProps;

const ListItems = ({ items, ...props }: ListItemsProps) => {
  const { t } = useTranslation();

  return (
    <List
      display='flex'
      flexDir='column'
      gap='xs'
      {...props}
    >
      {items.map((text) => (
        <ListItem
          key={text}
          alignItems='center'
          display='flex'
        >
          <ListIcon
            as={IconCircleCheckFilled}
            boxSize={5}
            color='green.500'
          />
          {t(text)}
        </ListItem>
      ))}
    </List>
  );
};

export default ListItems;
